import { LoginPayload, LogoutPayload } from 'models/auth'
import { API_EXPAND_TOKEN, API_LOGIN, API_LOGOUT } from '../configs/api'
import networkAdapter from '../utilities/networkAdapter'

export const login = (loginCredential: LoginPayload) => {
  return networkAdapter.post(API_LOGIN, loginCredential)
}

export const logout = (logoutPayload: LogoutPayload) => {
  return networkAdapter.post(API_LOGOUT, logoutPayload)
}

export const apiExpandToken = async (data: { app_id: string; device_token: string }) => {
  return networkAdapter.post(API_EXPAND_TOKEN, data)
}
